import ProtectedRoute from 'components/router/ProtectedRoute';
import { addressRoutes } from 'components/router/routes/addressRoutes';
import { adminRoutes } from 'components/router/routes/adminRoutes';
import { clientRoutes } from 'components/router/routes/clientRoutes';
import { customerRoutes } from 'components/router/routes/customerRoutes';
import { dashboardRoutes } from 'components/router/routes/dashboardRoutes';
import { financeRoutes } from 'components/router/routes/financeRoutes';
import { homeRoutes } from 'components/router/routes/homeRoutes';
import { loginWithGoogleRoutes } from 'components/router/routes/loginWithGoogleRoutes';
import { LTLRoutes } from 'components/router/routes/LTLRoutes';
import { orderPlaceRoutes } from 'components/router/routes/orderRoutes';
import { packagingRoutes } from 'components/router/routes/packagingRoutes';
import { paymentRoutes } from 'components/router/routes/paymentRoutes';
import { productTypeRoutes } from 'components/router/routes/productTypeRoutes';
import { profileRoutes } from 'components/router/routes/profileRoutes';
import { substationRoutes } from 'components/router/routes/substationRoutes';
import { termsAndConditionsRoutes } from 'components/router/routes/termsAndConditionsRoutes';
import { ticketRoutes } from 'components/router/routes/ticketRoutes';
import { userRoutes } from 'components/router/routes/userRoutes';
import Layout from 'components/UI/layout/Layout';
import TcLoading from 'components/UI/loading/TcLoading';
import routes from 'global/Constants/routes';
import useHasAccess from 'global/helperFunctions/useHasAccess';
import { Suspense, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Switch as SwitchTemp, useHistory, useLocation } from 'react-router-dom';
import { getCustomerUser } from 'redux/reducer/user/getCustomerUser';
import { getIsUserAllowedToMakeOrder } from 'redux/reducer/user/getIsUserAllowedToMakeOrder';
import { getPersonTotalBalance } from 'redux/reducer/user/getPersonTotalBalance';
import { getUserPersonFullInfo } from 'redux/reducer/user/getUserPersonFullInfo';
import { getWhoAmI } from 'redux/reducer/user/getWhoAmI';
import { userHandleLogout } from 'redux/reducer/user/userReducer';
import { RootState, store } from 'redux/store';
import { forgetPasswordRoutes } from './routes/forgetpasswordRoutes';

const Switch = SwitchTemp as any;

//type routeList = { path: string; component: React.LazyExoticComponent<React.FC>; isPrivate: boolean; accessRole: boolean };

function MainRouter() {
  const { theme } = useSelector((state: RootState) => state.setting);
  const { isLoggedIn, userProfile, customerUser, userPerson } = useSelector((state: RootState) => state.user);
  const refreshToken = localStorage.getItem('refreshToken');
  const token = localStorage.getItem('sessionid');
  const tokenExpiresAt = localStorage.getItem('tokenExpiresAt');
  const isTokenExpired = !tokenExpiresAt || Date.now() > +tokenExpiresAt;
  const needTokenRefresh = isTokenExpired && refreshToken && token;

  //hooks
  const hasAccessLevel = useHasAccess();
  const { pathname } = useLocation();

  const { push } = useHistory();

  //effect
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (needTokenRefresh) return;

    if (isLoggedIn) {
      store.dispatch(getWhoAmI());
    }
  }, [isLoggedIn, needTokenRefresh]);

  useEffect(() => {
    !isLoggedIn && pathname.startsWith('/recieverAddressTest') && push(routes.recieverAddressTest.path);
    isLoggedIn && pathname.startsWith(routes.login.path) && push(routes.dashboardHome.path);
    isLoggedIn && pathname.startsWith(routes.register.path) && push(routes.dashboardHome.path);
    !isLoggedIn && pathname.startsWith('/dashboard') && push(routes.login.path);
  }, [isLoggedIn]);

  useEffect(() => {
    userProfile && store.dispatch(getIsUserAllowedToMakeOrder());
    userProfile && userProfile.personId && store.dispatch(getPersonTotalBalance(userProfile.personId));
    userProfile && userProfile.personId && !userPerson && store.dispatch(getUserPersonFullInfo(userProfile.personId));
  }, [userProfile]);

  useEffect(() => {
    if (userProfile && !customerUser) store.dispatch(getCustomerUser(userProfile.id));
  }, [customerUser, userProfile]);

  //defaultSettings
  useEffect(() => {
    if (!localStorage.getItem('theme')) localStorage.setItem('theme', 'light');
    if (!localStorage.getItem('filterWrapperStatus')) localStorage.setItem('filterWrapperStatus', 'close');
  }, []);

  useEffect(() => {
    const root = document.querySelector(':root');
    if (!root) return;
    root.setAttribute('color-scheme', theme);
    theme === 'dark' && root.classList.add('dark');
    theme === 'light' && root.classList.remove('dark');
  }, [theme]);

  //constant
  const isProductionServer = process.env.REACT_APP_NOD_ENV === 'production';

  const routesList: any = useMemo(
    () => [
      //A
      //address
      ...addressRoutes(hasAccessLevel),
      //admin
      ...adminRoutes(hasAccessLevel),

      //C
      //customer
      ...customerRoutes(hasAccessLevel),

      //dashboard

      //F
      //finance
      ...financeRoutes(hasAccessLevel),
      //forgetpassword
      ...forgetPasswordRoutes(hasAccessLevel),

      //L
      //LoginWithGoogle
      ...loginWithGoogleRoutes(hasAccessLevel),

      //O
      //Order
      ...orderPlaceRoutes(hasAccessLevel),
      //ltl
      ...LTLRoutes(hasAccessLevel),

      //P
      //Profile
      ...profileRoutes(hasAccessLevel),
      ...productTypeRoutes(hasAccessLevel),

      //S
      //substation
      ...substationRoutes(hasAccessLevel),

      //T

      //termsAndConditions
      ...termsAndConditionsRoutes(hasAccessLevel),

      //U
      //userProfile
      ...userRoutes(hasAccessLevel),

      //M
      ...clientRoutes(hasAccessLevel),

      //P
      //packaging
      ...packagingRoutes(hasAccessLevel),
      //payment
      ...paymentRoutes(hasAccessLevel),

      ...dashboardRoutes(hasAccessLevel),
      //!!!! home routes shoud be at end
      //home
      ...homeRoutes(hasAccessLevel),
    ],
    []
  );

  //Ticket
  if (isProductionServer) {
    routesList.unshift(...ticketRoutes(hasAccessLevel));
  }

  const renderRoutes = useMemo(
    () =>
      routesList.map((route: any) => {
        return <ProtectedRoute key={route.path} {...route} />;
      }),
    []
  );

  const isShoabUser = userProfile && userProfile.userName.toLowerCase() == 'shoab1';
  if (isShoabUser) {
    store.dispatch(userHandleLogout());
    push(routes.login.path);
    return <></>;
  }

  return (
    <>
      <Layout>
        <Suspense fallback={<TcLoading className='grid h-screen place-items-center' />}>
          <Switch>{renderRoutes}</Switch>
        </Suspense>
      </Layout>
    </>
  );
}

export default MainRouter;
